import cn from "classnames";
import BookShow from "components/shared/book/show";
import Loader from "components/shared/loader";
import { dateToView } from "helpers/date";
import { serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import React from "react";
import { CustomScroll } from "react-custom-scroll";
import { config, initialState } from "./config";

class CounterpartyContractForm extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        const actions = [];
        if (!this.props.canEditBooks) {
            return actions;
        }
        actions.push({ text: "Удалить", action: this.actionClose });

        return actions;
    }

    actionClose = () => {
        const { modal, source, mergeParams, back, match } = this.props;
        return modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы действительно хотите удалить элемент?",
            onSuccessAction: () => {
                back();
                mergeParams();
            },
            buttons: { confirm: "Да", cancel: "Нет" },
            action: () => source.delItem({ id: this.state.data.id, counterpartyId: match.params.counterpartyId }),
        });
    };

    apply = () => {
        const { source, match, mergeParams, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                state.data.date = dateToView(state.data.date, "YYYY-MM-DD");
                return source.apply(serializeReq({ ...match.params, ...state.data })).then((res) => {
                    if (res) {
                        match.params.id ? this.update(mergeParams) : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        const { canEditBooks, match, back } = this.props;
        if (!canEditBooks) {
            return null;
        }
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row justify-content-between">
                <div className="btn btn-secondary btn-sm mr-2" onClick={back}>
                    Назад
                </div>
                <div>
                    {match.params.id && (
                        <div className="btn btn-danger btn-sm mr-2" onClick={this.actionClose}>
                            Удалить
                        </div>
                    )}
                    <div className={cname} onClick={this.apply}>
                        {match.params.id ? "Обновить" : "Создать"}
                    </div>
                </div>
            </div>
        );
    };

    setValue = ({ value, name }) => {
        const { data, initial } = this.state;
        const nextData = { ...data, [name]: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
        if (name === "date") {
            setTimeout(this.fillName, 0);
        }
    };

    fillName = () => {
        const { number, date, name } = this.state.data;
        if (number && date && !name) {
            this.setState({ data: { ...this.state.data, name: [number, dateToView(date)].join(" от ") } });
        }
    };

    render() {
        const { config, roles } = this.props;
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const disabled = !(
            roles.isTruckingOrganizationAdmin ||
            roles.isIntegrationManager ||
            roles.isTruckingOrganizationManager
        );
        return (
            <CustomScroll heightRelativeToParent="100%">
                <div className="container-fluid pb-3">
                    <div className="card card-body">
                        {this.renderCheckbox({ ...config.isMain, disabled })}
                        {this.renderField({ ...config.number, onBlur: this.fillName, disabled })}
                        {this.renderDateField({ ...config.date, onBlur: this.fillName, disabled })}
                        {this.renderField({ ...config.name, disabled })}
                        {this.renderSelect({ ...config.legalPersonId, disabled })}
                        {this.renderSelect({ ...config.invoiceTriggerType, disabled })}
                        {this.renderField({ ...config.settlementCurrency, disabled })}
                        {this.renderField({ ...config.paymentPeriod, disabled })}
                        {this.renderSelect({ ...config.paymentPeriodType, disabled })}
                        {this.renderSelect({ ...config.paymentTypeId, disabled })}
                        {this.renderField({ ...config.debtCeiling, disabled })}
                        {this.renderField({ ...config.currentDebt, disabled })}
                        {this.renderButton()}
                    </div>
                </div>
            </CustomScroll>
        );
    }
}

const ConfiguredShow = (props) => <CounterpartyContractForm {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "counterparty-contracts");
